
const digest = '2dddfa169b9388acaa3c311cfd7cb39b2d83280981de81738077c3fefb61587b';
const classes = {"wrapper":"_wrapper_s6lnm_1","buttonsWrapper":"_buttonsWrapper_s6lnm_11","text":"_text_s6lnm_16"};
const css = `._wrapper_s6lnm_1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: -34px -24px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  background: rgb(220, 233, 250);
  padding: 24px 24px;
}
._wrapper_s6lnm_1 ._buttonsWrapper_s6lnm_11 {
  display: flex;
  flex-direction: row;
  gap: 20px;
}
._wrapper_s6lnm_1 ._text_s6lnm_16 {
  color: #212357;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  